export const frontendData = [
  {
    id: 1,
    img: "url(https://c4.wallpaperflare.com/wallpaper/294/834/442/reactjs-facebook-javascript-minimalism-wallpaper-preview.jpg)",
    date: "May 29, 2013",
    urlLink: "https://reactjs.org/",
    title: "React Js",
    subTitle: "A JavaScript Library",
    description:
      "React makes it painless to create interactive UIs. Design simple views for each state in your application, and React will efficiently update and render just the right components when your data changes.",
  },
  {
    id: 2,
    img: "url(https://pbs.twimg.com/profile_images/875996174305472512/upM71pVR_400x400.jpg)",
    date: "February 2014",
    urlLink: "https://vuejs.org/",
    title: "Vue Js",
    subTitle: "Vue is  Framework",
    description:
      "Vue is a JavaScript framework for building user interfaces. It builds on top of standard HTML, CSS, and JavaScript and provides a declarative and component-based programming model that helps you efficiently develop user interfaces, be they simple or complex.",
  },
  {
    id: 3,
    img: "url(https://wallpaperaccess.com/full/3910941.jpg)",
    date: "October 20, 2010",
    urlLink: "https://angular.io/",
    title: "angular Js",
    subTitle: "Angular is Framework ",
    description:
      "Angular is an application-design framework and development platform for creating efficient and sophisticated single-page apps. These Angular docs help you learn and use the Angular framework and development platform, from your first application to optimizing complex single-page applications for enterprises. Tutorials and guides include downloadable examples to help you start your projects.",
  },
  {
    id: 4,
    img: "url(https://wallpaperaccess.com/full/1631875.jpg)",
    date: "1993",
    urlLink: "https://www.html.org.in/",
    title: "HTML",
    subTitle: "HyperText Markup Language",
    description:
      "The HyperText Markup Language or HTML is the standard markup language for documents designed to be displayed in a web browser.",
  },
  {
    id: 5,
    img: "url(https://wallpapercave.com/wp/wp2742472.jpg)",
    date: "August 05, 2023",
    urlLink: "https://drafts.csswg.org/",
    title: "CSS",
    subTitle: "Cascading Style Sheets",
    description:
      "React makes it painless to create interactive UIs. Design simple views for each state in your application, and React will efficiently update and render just the right components when your data changes.",
  },
  {
    id: 6,
    img: "url(https://cdn2.vectorstock.com/i/1000x1000/12/01/svelte-framework-logo-vector-28671201.jpg)",
    date: "	November 26, 2016",
    urlLink: "https://svelte.dev/",
    title: "svelte",
    subTitle: "Svelte is framework",
    description:
      "Svelte is a free and open-source front end component framework[4] or language[5] created by Rich Harris and maintained by the Svelte core team members.[6] Svelte is not a monolithic JavaScript library imported by applications: instead, Svelte compiles HTML templates to specialized code that manipulates the DOM directly, which may reduce the size of transferred files and give better client performance.[7] Application code is also processed by the compiler, inserting calls to automatically recompute data[4] and re-render UI elements when the data they depend on is modified.[8] This also avoids the overhead associated with runtime intermediate representations, such as virtual DOM,[9] unlike traditional frameworks (such as React and Vue) which carry out the bulk of their work at runtime, i.e in the browser.",
  },
  {
    id: 7,
    img: "url(https://keyholesoftware.com/wp-content/uploads/Backbone.js-Post-Image.jpg)",
    date: "October 13, 2010",
    urlLink: "https://backbonejs.org/",
    title: "Backbone Js ",
    subTitle: "It's an open-source component of DocumentCloud.",
    description:
      "Backbone.js gives structure to web applications by providing models with key-value binding and custom events, collections with a rich API of enumerable functions, views with declarative event handling, and connects it all to your existing API over a RESTful JSON interface.",
  },
  {
    id: 8,
    img: "url(https://www.altoros.com/blog/wp-content/uploads/2013/05/creating-javascript-app-with-emberjs-framework-1.png)",
    date: "December 8, 2011",
    urlLink: "https://emberjs.com/",
    title: "Ember Js",
    subTitle: "It's frontend A framework for ambitious web developers",
    description:
      "Ember is another open-source frontend framework to keep an eye on. It could assist you in developing modern user interfaces for internet solutions, mobile and desktop apps, and cross-platform applications.  ",
  },
  {
    id: 9,
    img: "url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJtLQwOsZBeM1klEi0ohlSLk4cndLnGRr5CsJ2eZ0wv4GBoCpxplg38j8RxbZ_KtKIcFI&usqp=CAU)",
    date: "August 26, 2006",
    urlLink: "https://jquery.com/",
    title: "jquery",
    subTitle: "It's an open-source component of DocumentCloud.",
    description:
      "jQuery is a fast, small, and feature-rich JavaScript library. It makes things like HTML document traversal and manipulation, event handling, animation, and Ajax much simpler with an easy-to-use API that works across a multitude of browsers. With a combination of versatility and extensibility, jQuery has changed the way that millions of people write JavaScript.",
  },
  {
    id: 10,
    img: "url(https://repository-images.githubusercontent.com/256277797/bf8eef80-800c-11ea-8058-eafb90a3271b)",
    date: "October 6, 2022",
    urlLink: "https://semantic-ui.com/",
    title: "semantic-uI",
    subTitle: "It's a front-end development framework similar to bootstrap.",
    description:
      "The Semantic Wikipedia would combine the properties of the Semantic Web and Wiki technology. In this enhancement, articles would have properties (or traits), which could be mixed or combined to allow articles to be members of dynamic categories, chosen by user requests. Lists would no longer be just the numerous pre-formatted list articles, but rather, a list could be dynamically created for all articles matching selected search properties.",
  },
  {
    id: 11,
    img: "url(https://mui.com/static/logo.png)",
    date: "May 2018",
    urlLink: "https://mui.com/",
    title: "MUI",
    subTitle: "Move faster with intuitive React UI tools",
    description:
      "MUI offers a comprehensive suite of UI tools to help you ship new features faster. Start with Material UI, our fully-loaded component library, or bring your own design system to our production-ready components.",
  },
];
